<template>
  <div id="optTechnical" class="optTechnical">
    <div class="Technical_dialog">
      <img class="qxsjImg" src="../assets/qxsj/qxsj.gif" alt="">
      <div class="box1">系统维护.....技术正在升级....（预计1-2天）</div>
      <div class="box2">升级Ai版本，让您获得最新体验，技术部都会彻夜赶工，请耐心等待~</div>
      <div class="box3">全新归来，必是惊喜不断~</div>
      <div class="dialog_close" @click="closeDialog()">好的，期待带来惊喜</div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  data() {
    return {
      
    }
  },
  created() {

  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  mounted() {

  },
  methods: {

    closeDialog() {
      this.$store.commit('setTechnical_Show',false)
    },

  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.optTechnical{
  position: absolute;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Technical_dialog {
  width: 550px;
  position: relative;
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 30px 40px;
  .qxsjImg{
    width: 130px;
  }
  .box1{
    font-size: 16px;
    color: black;
    font-weight: 700;
    margin:10px 0 0 ;
  }
  .box2{
    margin: 50px 0 30px;
    text-align: center;
    font-size: 14px;
    color: #666;
  }
  .box3{
    margin: 0 0 30px;
    text-align: center;
    font-size: 14px;
    color: #666;
  }

  .dialog_close {
    border-radius: 4px;
    background-color: #000;
    color: white;
    cursor: pointer;
    font-size: 14px;
    padding: 10px 50px;
  }

}
</style>